import Footer from "../components/Footer";
import ServiceImg from "../assets/img/servicepg.png";
import { useNavigate } from "react-router-dom";
import { SERVICE_LIST } from "../constants/services";
const Group = () => {
  return (
    // Mobile: vertical stacked, desktop: original horizontal with vectors
    <div
      className="w-full bg-[#051d62] text-white py-10 text-center 
                md:flex md:justify-between md:items-center 
                md:bg-transparent  md:py-0 "
    >
      {/* Mobile Layout */}
      <div className="space-y-10 md:hidden">
        <div>
          <p className="text-3xl font-semibold">99.5%</p>
          <p className="opacity-90 mt-1">Visas approved</p>
        </div>
        <div>
          <p className="text-3xl font-semibold">10000+</p>
          <p className="opacity-90 mt-1">Students Guided</p>
        </div>
        <div>
          <p className="text-3xl font-semibold">100%</p>
          <p className="opacity-90 mt-1">Student satisfaction</p>
        </div>
        <div>
          <p className="text-3xl font-semibold">2024</p>
          <p className="opacity-90 mt-1">Established</p>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="service-desktop-layout hidden md:flex md:w-full md:items-center md:justify-between md:gap-8 bg-[#051d62]">
        <div className="flex flex-col items-center text-center">
          <div className="text-3xl font-semibold">99.5%</div>
          <div className="opacity-80">Visas approved</div>
        </div>

        <img
          className="h-10"
          alt="Separator"
          src="https://c.animaapp.com/HwA6Ml4A/img/vector-24.svg"
        />

        <div className="flex flex-col items-center text-center">
          <div className="text-3xl font-semibold">10000+</div>
          <div className="opacity-80">Students Guided</div>
        </div>

        <img
          className="h-10"
          alt="Separator"
          src="https://c.animaapp.com/HwA6Ml4A/img/vector-25.svg"
        />

        <div className="flex flex-col items-center">
          <div className="text-3xl font-semibold">100%</div>
          <div className="opacity-80">Student satisfaction</div>
        </div>

        <img
          className="h-10"
          alt="Separator"
          src="https://c.animaapp.com/HwA6Ml4A/img/vector-26.svg"
        />

        <div className="flex flex-col items-center">
          <div className="text-3xl font-semibold">2024</div>
          <div className="opacity-80">Established</div>
        </div>
      </div>
    </div>
  );
};

const Container = () => {
  return (
    <div className="container md:mt-10 md:px-0">
      <p className="p-2 text-wrapper-12">Your Complete Partner in Global Education</p>

      <p className="from-initial">
        From initial consultation to graduation day, we provide comprehensive
        support services to
        <br />
        ensure your success in the Global education system.
      </p>
    </div>
  );
};

export default function Services() {
  const navigate = useNavigate();

  return (
    <div className="services">
      {/* MOBILE HERO + TEXT */}
      <section className=" pt-2 pb-0 text-center md:hidden">
        <h2 className="text-[28px] font-semibold text-[#051d62] leading-tight">
          Supporting your Global <br />
          <span className="text-blue-700">education aspirations</span>
        </h2>

        <p className="mt-4 text-gray-600 text-[16px] leading-relaxed">
          Begin your journey to study abroad at a top-ranking university with
          support from the world’s most trusted higher education specialist
        </p>

        <img
          className="w-full mt-4 rounded-lg"
          src={ServiceImg}
          alt="Students"
        />
      </section>

      {/* DESKTOP HERO + TEXT */}
      <div className="hidden md:block">
        <div className="services-rectangle">
          <div className="frame">
            <div className="service-div-2">
              <div className="service-text-wrapper-2">Supporting your Global</div>

              <div className="service-text-wrapper-3">
                education aspirations
              </div>
            </div>

            <p className="p">
              Begin your journey to study abroad at a top-ranking university
              with support from the world’s most trusted higher education
              specialist
            </p>
          </div>

          <img
            className="services-rectangle-2"
            alt="Rectangle"
            src={ServiceImg}
          />
        </div>
      </div>

      {/* STATS SECTION */}
      <Group />

      <div className="service-background-container">
        {/* CONTAINER (unchanged) */}
        <Container />

        {/* SERVICES CARDS */}
        <section className=" px-5 py-16 bg-white service-card-section">
          <div className="grid md:grid-cols-3 gap-8">
            {SERVICE_LIST.map((svc, idx) => (
              <div
                key={idx}
                className="p-6 border rounded-lg shadow hover:shadow-lg"
              >
                <img className="image-overlay" alt="Overlay" src={svc.img} />
                <div className="card-text-container">
                  <h3 className="card-text-wrapper font-semibold text-lg mb-3">
                    {svc.title}
                  </h3>
                  <p className="card-text-desc text-gray-600 mb-3">
                    {svc.desc}
                  </p>
                </div>
                <button
                  onClick={() => navigate(svc.route)}
                  className="card-btn card-btn-text text-white-700 font-medium"
                >
                  Learn more
                </button>
              </div>
            ))}
          </div>
        </section>
      </div>

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
